import $ from 'jquery';
import { elemExists } from './helper';
import initAllSwiper from './swiper';
// import pageHeader froCm "./pageheader";
// import MicroModal from 'micromodal';
import initSlideout from './slideout';
// import Foundation from 'foundation-sites';
// import initObserver from './animations';
import { initAccordions } from "./accordion";
import initMaps from './maps';

// MicroModal.init();
const modalOpener = document.querySelector('.js-open-modal');
if(modalOpener !== null) {
	modalOpener.addEventListener('click', function() {
		console.log('Element geklickt');
		MicroModal.show('modal-1');
	});
}


// init page start animation
const startAnimation = () => {

	const Overlay = document.querySelector('.blackOverlay');
	const IntroImage = document.querySelector('.intro-teaser-image');
	const IntroImageWrap = document.querySelector('.intro-teaser-image-wrap');

	if (elemExists(Overlay)) {
		Overlay.addEventListener('animationend', () => {
			Overlay.classList.add('done');

			if (elemExists(IntroImage)) {
				IntroImage.classList.add('animate');
			}

			if (elemExists(IntroImageWrap)) {
				IntroImageWrap.classList.add('animate');
			}
		});
	}
}

// function initAccordionsMenu() {

// 	const options = {
// 		submenuToggle: true
// 	};
// 	const elem = new Foundation.AccordionMenu($('.js--accordion-menu'), options);
// }

// init this script
initAccordions( $('.js--accordion') );
// initAccordionsMenu();

// initObserver();

// init google maps
initMaps();

initAllSwiper();

// init Animation
// startAnimation();

// init slideout with defined settings
initSlideout();
